//Archivo dedicado al menu de todos los imports del Registro de Ordenes de Protección

//-----------Principal-----------
import Plantilla from '@/components/REGOP/Comun/Plantilla.vue';

//-----------Administración------------
import RegistrodeOrdenes from '@/components/REGOP/Administracion/RegistrodeOrdenes.vue';

//Se crea la lista de paths
const REGOP = 
[
    { 
        name: 'REGOP', 
        path: '/REGOP/', 
        component: Plantilla, 
        meta: { 
            tituloDeLaPagina: "Registro de Órdenes de Protección", 
            RequiereAutenticacion: true, 
            ValidaSesion: true, 
            ObtenDatos: true, 
            ObtenPermisosDelSistema: true, 
            SistemaQueSeIngreso: 44 }, 
    
        children: 
        [
            { 
            name: 'RegistrodeOrdenes', 
            path: 'RegistrodeOrdenes', 
            component: RegistrodeOrdenes,  
            meta: { 
                tituloDeLaPagina: "Registro de Órdenes de Protección", 
                RequiereAutenticacion: true, 
                ValidaSesion: true, 
                ObtenDatos: true, 
                ObtenPermisosDelSistema: false, 
                SistemaQueSeIngreso: 44, 
                EsRequeridoValidacionDeInstitucion: true } 
            }
        ] 
    }
];

//Se regresa la lista de paths
export default REGOP;




// WEBPACK FOOTER //
// ./src/router/REGOP.js